
import { Component, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { ConfigProvider } from '../../providers/config/config';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { trigger, style, animate, transition } from '@angular/animations';
import { NavController, Content } from 'ionic-angular';
import { SubCategories6Page } from '../sub-categories6/sub-categories6';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { LoadingProvider } from '../../providers/loading/loading';

declare var Stripe;


@Component({
  selector: 'page-payments',
  templateUrl: 'payments.html'
})




export class PaymentsPage {
  stripe = Stripe('pk_live_51HtXWDEUn6fDxgIsE8iVie35UWaOc9A3KXu45W3HcOqoFcJjKvQ4AaOckXX4X1n6CqNNaY209Yn93fAwFsnQsP2d00SuLTAbPI');
  card: any;
  error = "";
  cardholder_name = '';
  cardholder_postcode = '';
  monthlyprice = '';
  httpRunning = true;
  @ViewChild(Content) content: Content;

  constructor(
    public http: Http,
    public loading: LoadingProvider,
    public config: ConfigProvider,
    public shared: SharedDataProvider,
    public navCtrl: NavController,
    translate: TranslateService) {


  }

  ionViewDidLoad() {
    this.monthlyprice = '20';
    var data: { [k: string]: any } = {};

    this.http.post(this.config.url + 'getPricing', data).map(res => res.json()).subscribe(data => {
      this.httpRunning = false;
      if (data.success == 1) {
        console.log("Pricing:",data.data);
        this.monthlyprice = data.data[0].price_monthly;
        }
      // $scope.$broadcast('scroll.refreshComplete');
    },
      function (response) {

        this.alert.show("Server Error while Loading Orders");
        //console.log(response);
      });

  this.setupStripe();
}


  setupStripe(){

    let elements = this.stripe.elements();

    var elementStyles = {
      base: {
        color: '#32325D',
        fontWeight: 500,
        fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
        fontSize: '16px',
        fontSmoothing: 'antialiased',

        '::placeholder': {
          color: '#CFD7DF',
        },
        ':-webkit-autofill': {
          color: '#e39f48',
        },
      },
      invalid: {
        color: '#E25950',

        '::placeholder': {
          color: '#FFCCA5',
        },
      },
    };

    var elementClasses = {
      focus: 'focused',
      empty: 'empty',
      invalid: 'invalid',
    };


  var cardNumber = elements.create('cardNumber', {
    style: elementStyles,
    classes: elementClasses,
  });
  cardNumber.mount('#card-number');

  var cardExpiry = elements.create('cardExpiry', {
    style: elementStyles,
    classes: elementClasses,
  });
  cardExpiry.mount('#card-expiry');

  var cardCvc = elements.create('cardCvc', {
    style: elementStyles,
    classes: elementClasses,
  });
  cardCvc.mount('#card-cvc');



//this.card = elements.create('card', { style: style });

//this.card.mount('#card-element');

//this.card.addEventListener('change', event => {
//  var displayError = document.getElementById('card-errors');
//  if (event.error) {
//    displayError.textContent = event.error.message;
//  } else {
//    displayError.textContent = '';
//  }
//});
this.registerElements([cardNumber, cardExpiry, cardCvc]);

}

registerElements(elements){
  var form = document.getElementById('payment-form');
  var savedErrors = {};

  elements.forEach(function(element, idx) {
  element.on('change', function(event) {
    if (event.error) {
      //error.classList.add('visible');
      //savedErrors[idx] = event.error.message;
      //errorMessage.innerText = event.error.message;
    } else {
      savedErrors[idx] = null;

      // Loop over the saved errors and find the first one, if any.
      var nextError = Object.keys(savedErrors)
        .sort()
        .reduce(function(maybeFoundError, key) {
          return maybeFoundError || savedErrors[key];
        }, null);

      if (nextError) {
        // Now that they've fixed the current error, show another one.
        //errorMessage.innerText = nextError;
      } else {
        // The user fixed the last error; no more errors.
        //error.classList.remove('visible');
      }
    }
  });
});

//Listen on the forms submit Handler
var form = document.getElementById('payment-form');
form.addEventListener('submit', event => {
  event.preventDefault();
  // Gather additional customer data we may have collected in our form.
  var name = this.cardholder_name;
  var zip = this.cardholder_postcode;

  var additionalData = {
   name: name,
   address_zip: zip,
 };
 console.log("Additional Data:",additionalData);
  // this.stripe.createSource(this.card)
  this.stripe.createToken(elements[0], additionalData).then(result => {
    if (result.error) {
      console.log("Got Error:",result.error.message);
      this.error = result.error.message;
    } else {

      this.makePayment(result.token.id);
    }
  });
});

}

makePayment(token) {
  this.loading.show();
this.http
.post(this.config.url + 'paywithStripe', {
amount: 100,
currency: "gbp",
token: token,
ar_id:this.shared.customerData.customers_id,
ar_email:this.shared.customerData.ar_email_address
})
.subscribe(data => {
console.log(data);
swal({title: "Success!",text: "Your subscription was successful",icon: "success"}).then((value) => {
    //this.navCtrl.push(HomePage);
this.loading.hide();
this.navCtrl.popToRoot();
    //this.shared.login(data.data[0]);
});

});
}

  ngAfterViewChecked(){
    this.content.resize();
  }

// ionViewWillEnter() {
//   if (this.config.admob == 1) this.shared.showAd();
// }

}



// WEBPACK FOOTER //
// ./src/pages/payments/payments.ts